import React from 'react';

/**
 * Traffic light for activation status (not SIM lifecycle).
 */
export default function TrafficLight({ status, animate = false }) {
  const colorFor = (s) => {
    switch (s) {
      case 'active':
        return '#28a745';
      case 'activating':
      case 'handing_over':
      case 'queued':
        return '#ffc107';
      case 'error':
        return '#dc3545';
      default:
        return '#6c757d';
    }
  };

  const color = colorFor(status);
  const showGlow = status !== 'inactive';

  return (
    <>
      <style>
        {`
          @keyframes port-activation-pulse {
            0% { transform: scale(1); opacity: 1; }
            50% { transform: scale(1.15); opacity: 0.8; }
            100% { transform: scale(1); opacity: 1; }
          }
        `}
      </style>
      <span
        role="img"
        aria-label={`activation-${status}`}
        className="rounded-circle me-1"
        style={{
          display: 'inline-block',
          width: '10px',
          height: '10px',
          backgroundColor: color,
          border: '1px solid rgba(0,0,0,0.1)',
          borderRadius: '50%',
          animation: animate ? 'port-activation-pulse 1.5s ease-in-out infinite' : 'none',
          boxShadow: showGlow ? `0 0 6px ${color}40` : 'none',
        }}
        title={status}
      />
    </>
  );
}
